<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="4">
        <el-select v-model="typedate" @change="typedateSelectHandle" placeholder="有效期的类型"
                   style="width: 100%;">
          <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="卡券名称" v-model="title"><el-button slot="append" icon="el-icon-search" @click="titleSearch"></el-button></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="卡券编号" v-model="series"><el-button slot="append" icon="el-icon-search" @click="titleSearch"></el-button></el-input>
      </el-col>
      <el-col :span="6" >
        <el-date-picker v-model="create_time" type="daterange" start-placeholder="开始日期" ange-separator="至" end-placeholder="结束日期" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width: 100%;" @change="dateChange" ></el-date-picker>
      </el-col>
      <el-col :span="4">
          <el-select v-model="cate_id" clearable placeholder="请选择优惠券分类" @change="search">
              <el-option v-for="item in category" :key="item.value" :label="item.name" :value="item.cate_id"> </el-option>
          </el-select>
      </el-col>
    </el-row>
    <div v-if="$route.path.indexOf('_detail') === -1 && $route.path.indexOf('_editor') === -1 ">
      <div class="content-bottom-padded">
        <el-button type="success" icon="plus" @click="syncCoupon">同步优惠券</el-button>
        <el-button type="primary" icon="plus" @click="addCoupon">创建优惠券</el-button>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-for="(item,index) in tabList" :key="index" :label="item.name" :name="item.activeName">
        <el-table :data="cardList" :height="wheight-140" @filter-change="filterTag" v-loading="loading" @selection-change="handleSelectionChange">
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
          <el-table-column prop="card_id" label="卡券id"></el-table-column>
          <el-table-column prop="series" label="券编号"></el-table-column>
          <el-table-column prop="card_type" column-key="type" label="卡券类型" width="180" :filters="typeFilters" filter-placement="bottom-end">
            <template slot-scope="scope">
              {{ scope.row.card_type | formatCardStr }}
            </template>
          </el-table-column>
          <el-table-column prop="title" label="卡券名称"> </el-table-column>
          <el-table-column prop="str_title" label="精简标题"> </el-table-column>
          <el-table-column prop="name" label="卡券分类"> </el-table-column>
          <el-table-column prop="sort" label="排序">
            <template slot-scope="scope">
              <div v-if="scope.row.card_id !== currentId">
                {{scope.row.sort}}
                <i  class="el-input__icon el-icon-edit" @click="editPrice(scope.row.card_id, scope.row.sort)"></i>
              </div>
              <el-input v-else v-model="currentsort"   @blur="handleBlur(scope.$index,scope)" size="mini" :ref="'input_' + scope.row.card_id"></el-input>
            </template>
          </el-table-column>
          <el-table-column  label="卡券有效期">
            <template slot-scope="scope">
              <template v-if="scope.row.takeEffect">
                {{scope.row.takeEffect}}
              </template>
              <template v-else>
                {{scope.row.begin_time | datetime}} <template v-if="scope.row.end_time">~</template> {{scope.row.end_time | datetime}}
              {{ Date.parse(new Date()) > scope.row.end_time*1000 ? '已过期' : ''}}
              </template>
            </template>
          </el-table-column>
          <!-- <el-table-column label="推送至微信">
            <template slot-scope="scope">
              <template v-if="scope.row.if_push_wechat">
                已推微信
              </template>
            </template>

          </el-table-column> -->
          <!-- <el-table-column prop="status" column-key="status" label="投放状态" :filters="statusFilters" filter-placement="bottom-end">
            <template slot-scope="scope">
              {{ scope.row.status | formatStatusStr }}
            </template>
          </el-table-column> -->
          <el-table-column label="可领取库存" align="right">
            <template slot-scope="scope">
              <span v-if="parseInt(scope.row.quantity) > parseInt(scope.row.get_num)">{{parseInt(scope.row.quantity) - parseInt(scope.row.get_num)}}</span> <span v-else>0</span>
              <el-popover
                  placement="bottom"
                  width="300"
                  trigger="click"
                  v-model="scope.row.storePop"
                  >
                <div ref="store" class="store-pop">
                  <div class="store-content">
                    <el-radio-group v-model="scope.row.operationType" class="content-bottom-padded">
                      <el-radio label="increase">增加</el-radio>
                      <el-radio label="reduce">减少</el-radio>
                    </el-radio-group>
                    <el-row>
                      <el-col :span="22">
                        <el-input placeholder="库存不能少于1" v-model="scope.row.storeValue"></el-input>
                      </el-col>
                      <el-col :span="2" style="line-height: 36px;" class="content-center">份</el-col>
                    </el-row>
                  </div>
                  <el-row :gutter="10">
                    <el-col :span="12"><el-button type="primary" style="width: 100%" @click="saveStore(scope.$index, scope.row.operationType)">确定</el-button></el-col>
                    <el-col :span="12"><el-button style="width: 100%" @click="scope.row.storePop = false">取消</el-button></el-col>
                  </el-row>
                </div>
                <i slot="reference" class="el-icon-edit"></i>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="get_num" label="领取量">
            <!-- <template v-if="scope.row.get_num">{{scope.row.get_num}}</template> -->
            <!-- <template>0</template> -->
          </el-table-column>
          <el-table-column prop="use_num" label="使用量">
            <!-- <template v-if="scope.row.use_num">{{scope.row.use_num}}</template> -->
            <!-- <template>0</template> -->
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <el-switch  v-model="scope.row.is_hidden" active-value="0"  inactive-value="1"  active-color="#13ce66"  inactive-color="#ff4949" @change="switchChange(scope.$index, scope.row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column width="150" label="操作">
            <template slot-scope="scope">
              <div class="operating-icons">
                <router-link class="iconfont icon-search-plus" :to="{path: matchHidePage('detail'), query: { chooseCardtype: scope.row.card_type, cardId: scope.row.card_id, title: scope.row.title }}"></router-link>
                <router-link class="iconfont icon-edit1" :to="{path: matchHidePage('editor'), query: { chooseCardtype: scope.row.card_type, cardId: scope.row.card_id }}"></router-link>


                <i class="mark iconfont icon-trash-alt1" v-if="scope.row.status != 'CARD_STATUS_DISPATCH'" @click="deleteCard(scope.row.card_id, scope.$index)"></i>

              </div>
              <a  href="#" @click="downloadCard(scope.row.card_id, scope.$index)">下载卡号</a>
              <el-button type="text" @click="handUpCard(scope.row.series, scope.$index)">更新优惠券</el-button>
              <!-- <a v-if="!scope.row.ifpass" href="#" @click="sendoutShowAction(scope.row.card_id, scope.$index)">投放</a> -->
            </template>
          </el-table-column>
          <el-table-column label="下载码">
            <template slot-scope="scope">
              <el-button type="text" @click="showQR(scope.row)"     >app维码</el-button>
              <el-button type="text" @click="showQRWxapp(scope.row)">小程序码</el-button>
            </template>
          </el-table-column>

        </el-table>
        </el-tab-pane>
      </el-tabs>
      <div class="content-padded content-center">
        <!-- <el-pagination
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :total='pagers.total'
          :page-sizes="[10,20,50]"
          :page-size="pageSize">
        </el-pagination> -->
        <el-pagination
              background
              layout="total, sizes, prev, pager, next"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :current-page.sync="fetchParams.currentPage"
              :page-sizes="[10,20,50,100]"
              :total="pagers.total"
              :page-size="fetchParams.pageSize">
            </el-pagination>
      </div>

      <el-dialog title="您可以通过以下方式投放" :visible.sync="sendoutVisible">
        <div class="sendout-item" v-for="(item, index) in sedoutList" :key="" :class="{'checked': currSendout===index}" @click="chooseSendout(index)">
          <div>{{ item.name }}</div>
          <div class="icon-checked">
            <i class="el-icon-circle-check"></i>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="sendoutVisible = false">取消</el-button>
          <el-button type="primary" @click.native="sendoutAction">确定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="下载卡号" :visible.sync="downCardShow">
        <el-row :gutter="10" class='batch_price'>
          <el-input v-model="downcardnum" class='pri-inp' placeholder="下载数量"  type="text"></el-input>

        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="downCardShow = false">取消</el-button>
          <el-button type="primary" @click.native="downloadCardcheck">确定</el-button>
        </div>
      </el-dialog>


    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getCardList, getQRcode, removeCard, updateStore, pushToWechat,updateCardHidden,updateCardSort ,getCateList,getCouponQRcode,downLoadCardCode,syncKaquanList, hand2UpCard} from '../../../api/cardticket'
import util from '../../../common/js/util'


export default {
  props: {
      isLoad: {
          type: Boolean,
          default: true
      },
  },
  provide() {
    return {
      refresh: this.getCardList
    }
  },
  data () {
    return {
      cate_id:'',
      loading: false,
      sendoutVisible: false,
      currSendout: 1,
      checkedType: {},
      cardList: [],
      pagers:{
        total: 0
      },
     downCardShow: false,
     downCardid:'',
     downcardnum:'',
     currentId: '',
     currentsort:'',
     create_time:'',
     time_start_begin: '',
     time_start_end: '',
     activeName: 'first',
     category:[],
     title:'',
     typedate:'',
     series:'',
     downCouponVal:false,
     qrcode:'',
     rowdata:{},
     options: [
         {value: 'DATE_TYPE_FIX_TERM', label: '领取后生效'},
         {value: 'DATE_TYPE_FIX_TIME_RANGE',label: '固定日期生效'}
         ],
     tabList: [
        {name: "全部", value: null, activeName: 'first'},
        {name: "直接领取", value: 'true', activeName: 'second'},
        {name: "后台发放", value: 'true', activeName: 'third'},
        {name: "有效优惠券", value: 'true', activeName: 'fourth'},
        {name: "失效优惠券", value: 'true', activeName: 'fifth'},
     ],
      typeId: -1,
      pageSize:20,
      currentPage:1,
      sedoutList: [
        //{ name: '直接群发', id: 1 },
        //{ name: '嵌入图文消息', id: 2 },
        { name: '下载二维码', id: 3 }
      ],
      couponList: [
        { type: 'discount', name: '折扣券', desc: '可为用户提供消费折扣支持优惠抵扣快速买单' },
        { type: 'cash', name: '代金券', desc: '可为用户提供抵扣现金服务。可设置成为“满*元，减*元”，支持优惠抵扣快速买单' },
        { type: 'gift', name: '兑换券', desc: '可为用户提供消费送赠品服务' },
        { type: 'free_shipping', name: '免邮券', desc: '可为用户提供消邮费减免服务' },
        { type: 'service', name: '服务券', desc: '可为用户提供服务' },
      ],
      params: {},
      typeFilters: [{
         text: '折扣券',
         value: 'discount'
        },
        {
          text: '代金券',
          value: 'cash'
        },
        {
          text: '兑换券',
          value: 'gift'
        },
        {
          text: '免邮券',
          value: 'free_shipping'
        },
        {
          text: '服务券',
          value: 'service'
        }
      ],
      statusFilters: [{
         text: '待审核',
         value: 'CARD_STATUS_NOT_VERIFY'
        },
        {
          text: '待投放',
          value: 'CARD_STATUS_VERIFY_OK'
        },
        {
          text: '已投放',
          value: 'CARD_STATUS_DISPATCH'
        },
        {
          text: '审核失败',
          value: 'CARD_STATUS_VERIFY_FAIL'
      }],
      fetchParams: {
        currentPage: 1,
        card_type: '',
        status: '',
        kaquanstatus:'',
        begin_date:'',
        end_date:'',
        title:'',
        datatype:'',
        pageSize: 20,
        cate_id:'',
      },
      multipleSelection:[]
    }
  },
  filters: {
    formatStatusStr(str) {
      switch (str) {
        case 'CARD_STATUS_NOT_VERIFY':
          str = '待审核'
          break
        case 'CARD_STATUS_VERIFY_OK':
          str = '待投放'
          break
        case 'CARD_STATUS_DISPATCH':
          str = '已投放'
          break
        case 'CARD_STATUS_VERIFY_FAIL':
          str = '审核失败'
          break
      }
      return str
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    handleCurrentChange(val) {
      this.fetchParams.currentPage = val
      this.getCardList()
    },
    handleSizeChange (pageSize) {
      this.fetchParams.currentPage = 1
      this.fetchParams.pageSize = pageSize
      this.getCardList()
    },
    handleClick (tab, event) {
        if (tab.name == 'second') {
            this.fetchParams.kaquanstatus = 2
        } else if (tab.name == 'third') {
            this.fetchParams.kaquanstatus = 3
        } else if(tab.name == 'fourth'){
            this.fetchParams.kaquanstatus = 4
        } else if(tab.name == 'fifth'){
            this.fetchParams.kaquanstatus = 5
        }else {
            this.fetchParams.kaquanstatus = 1
        }

        this.params.page = 1
        this.getCardList()
    },
    addCoupon () {
      this.$router.push({path: this.matchHidePage('editor')})
    },
    syncCoupon(){
      this.$confirm('确定要同步中台优惠券到多店铺？', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            syncKaquanList().then((res)=>{
              if(res){
                loading.close();
                  this.$message({
                  message: res.data.data.msg,
                  type: 'success',
                  duration: 2000
                })
              }

            })
          }
        done()
        }
      })
    },
    sendoutShowAction (id) {
      this.sendoutVisible = true
      this.typeId = id
      this.currSendout = 0
    },
    sendoutAction () {
      if (this.currSendout == 0) {
        if (this.typeId) {
          getQRcode(this.typeId).then(res => {
            var a = document.createElement('a')
            a.href = res.data.data.show_qrcode_url
            a.download = true
            a.click()
          })
        }
      }
      this.sendoutVisible = false
    },
    chooseType (item, index) {
      this.i = index
      this.checkedType = item
    },
    titleSearch(){
        this.fetchParams.title = this.title
        this.fetchParams.series = this.series
        this.params.page = 1
        this.getCardList()
    } ,
    dateStrToTimeStamp (str) {
      return Date.parse(new Date(str))/1000
    },
    typedateSelectHandle(){
        // this.fetchParams.datatype = this.
        this.fetchParams.datatype = this.typedate
        this.params.page = 1
        this.getCardList()
    },
    showQR(row){
        // this.rowdata = row
        // this.downCouponVal = true
        let params = {card_id:row.card_id,type:'app'}

        getCouponQRcode(params).then(response => {
            var a = document.createElement('a')
            var temp = '微商城'
            a.href = response.data.data.qrcode_url
            if (response.data.data.tempname) {
                var temp = response.data.data.tempname
            }
            a.download = temp + row.title + '.png'
            a.click()
        })
    },
    showQRWxapp(row){
        let params = {card_id:row.card_id,type:'wxapp'}

        getCouponQRcode(params).then(response => {
            var a = document.createElement('a')
            var temp = '微商城'
            a.href = response.data.data.qrcode_url
            if (response.data.data.tempname) {
                var temp = response.data.data.tempname
            }
            a.download = temp + row.title + '.png'
            a.click()
        })
    },
    dateChange (val) {
       if(val) {
           if (val.length > 0) {
               this.fetchParams.begin_date = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
               this.fetchParams.end_date = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
           } else {
               this.fetchParams.begin_date = ''
               this.fetchParams.end_date = ''
           }
       }else{
           this.fetchParams.begin_date = ''
           this.fetchParams.end_date = ''
       }
        this.params.page = 1
        // this.getParams()
        // this.getOrders(this.params)
        this.getCardList()
    },
    deleteCard (id, index) {
      this.$confirm('确定要删除该卡券？', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            removeCard({'card_id':id}).then( res => {
              this.cardList.splice(index, 1)
            })
          }
        done()
        }
      })
    },
    // 显示下载优惠券卡号
    downloadCard(id,index){
      this.downCardShow = true
      this.downCardid = id
    },
    downloadCardcheck(){
      // 下载优惠券卡号
      var downprams={
        card_id:this.downCardid,
        nums:this.downcardnum,
      };
      downLoadCardCode(downprams).then(res => {
        if (res.data.data.status) {
          this.$message({
            message: '已添加到队列,请在设置，导出列表，优惠券码中下载',
            type: 'success',
            duration: 2 * 1000
          })
        }
      })
    },
    handUpCard(series){
      // 要更新的优惠券 series
      var params ={
        series: series,
      };
      this.$confirm('确定要更新优惠券信息？', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning',
      }).then(() => {
        hand2UpCard(params).then(res => {
          if (res.data.data.list) {
            this.$message({
              message: '优惠券更新成功',
              type: 'success',
              duration: 2 * 1000
            })
          }
        })
      })
    },
    chooseSendout (index) {
      this.currSendout = index
    },
    pullWechatCard () {
      this.$confirm('确定同步微信优惠券到本系统吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          pullWechatCard().then(response => {
            this.$message({
              message: '同步成功',
              type: 'success',
              duration: 5 * 1000
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    editPrice(id, sort) {
        this.currentId = id
        this.currentsort = sort
        let self = this
        this.$nextTick(() => {
            self.$refs['input_' + id].focus()
        })
    },
    handleBlur(index,scope) {
        if (this.currentsort == scope.row.sort) {
            this.currentId = -1
            this.currentsort = ''
            return
        }
        let form = {}
        form = {"card_id": scope.row.card_id, "sort":this.currentsort }

        updateCardSort(form).then(res => {
            this.$message({
                type: 'success',
                message: '修改成功',
                duration: 1000
            })
        })

        scope.row.sort = this.currentsort
        this.currentId = -1
        this.currentsort = ''
      },
    getCardList () {
      this.loading = true
      var params = {
        status: this.fetchParams.status,
        card_type: this.fetchParams.card_type,
        page_no: this.fetchParams.currentPage,
        page_size: this.fetchParams.pageSize,
        kaquanstatus: this.fetchParams.kaquanstatus,
        begin_date: this.fetchParams.begin_date,
        end_date: this.fetchParams.end_date,
        date_type: this.fetchParams.datatype,
        title:this.fetchParams.title,
        series:this.fetchParams.series,
        cate_id:this.fetchParams.cate_id
      }
      // alert(this.fetchParams.kaquanstatus)
      getCardList(params).then(res => {
        if(res.data.data.list.length > 0) {
          this.cardList = res.data.data.list
          this.pagers.total = res.data.data.pagers.total
          this.loading = false
        } else {
          this.cardList = []
          this.loading = false
        }
      })
      .catch( error => {
        this.loading = false
      })
    },
    filterTag (value) {
      if (value.type) {
        this.fetchParams.card_type = value.type
        this.getCardList()
      }
      if (value.status) {
        this.fetchParams.status = value.status
        this.getCardList()
      }

    },
    saveStore (index, operationType) {
      let reg = /^[1-9]\d*$/
      if (!reg.test(this.cardList[index].storeValue)) {
        this.$message({
          message: '请输入大于0的正整数',
          type: 'error'
        })
        return
      }
      if (operationType == 'reduce') {
        var quantity = Number(this.cardList[index].quantity) > this.cardList[index].get_num ? Number(this.cardList[index].quantity) - this.cardList[index].get_num : 0
        if (this.cardList[index].storeValue > quantity) {
          this.$message({
            message: '减少数量不能大于可领取库存',
            type: 'error'
          })
          return
        }
      }
      var param = {
        card_id: this.cardList[index].card_id,
        type: this.cardList[index].operationType,
        quantity: this.cardList[index].storeValue
      }
      updateStore(param).then(response => {
        this.getCardList()
      })
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    switchChange (index, row) {

      this.$confirm('确定要修改该卡券的状态？', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          console.log(instance,444)
          if (action === 'confirm') {
            var params = {
              'card_id': row.card_id,
              'show': row.is_hidden == 1 ? 'hidden' : 'show'
            }
            updateCardHidden(params).then(response => {
              this.getCardList()
              if (response.data.data.status == true) {
                this.$message({
                  type: 'success',
                  message: '状态修改成功'
                })
              }
              else{
                this.$message({
                  type: 'error',
                  message: '状态修改失败'
                })
              }
            })
          }
          else{
            this.getCardList()
          }
        done()
        }
      })

    },
    search () {

        this.fetchParams.cate_id = this.cate_id
        console.log(this.fetchParams);
        this.getCardList()
    },
    pushWechatCard () {
      var selectCardId = []
      for (var i=0; i < this.multipleSelection.length; i++) {
        selectCardId.push(this.multipleSelection[i].card_id)
      }
      var param = {card_ids: selectCardId}
      this.$confirm('确定同步选中的优惠券至微信么？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
        pushToWechat (param).then(res => {
          if (res.data.data.status) {
            this.$message({
              message: '已经加入上传队列，请稍后查看状态',
              type: 'success',
              duration: 5 * 1000
            })
            //this.$refs.multipleTable.clearSelection();
          } else {
            this.$message({
              message: '推送出错',
              type: 'error'
            })
            return
          }
        })
      })
    }
  },
  mounted () {
   // this.getCardList()
   getCateList({page:1,pageSize:-1}).then(res=>{
        if(res.data){
            this.category = res.data.data.list
        }
    })
    this.$nextTick(() => {
        if (this.isLoad) {
            this.getCardList()
        }
    })
  }
}

</script>
<style scoped lang="scss">
  .el-icon-edit {
    cursor: pointer;
  }
  .coupon-list {
    margin-top: 10px;
  }
  .coupon-item {
    position: relative;
    height: 130px;
    padding: 25px 20px;
    overflow: hidden;
    background: #fff;
    border: 1px solid #dadadd;
    border-radius: 5px;
    text-align: center;
    font-size: 14px;
    width: 19%;
    float: left;
    margin: .5%;
    &.coupon-add {
      padding-top: 20px;
      cursor: pointer;
      i {
        font-size: 40px;
      }
      :last-child { margin-top: 10px; }
    }
    .price {
      font-size: 24px;
    }
    .color-gray {
      color: #99A9BF;
    }
    .color-gray-deep {
      color: #8492A6;
    }
    .item-code {
      display: inline-block;
      width: 90%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    span.icon-triangle {
      position: absolute;
      top: 0;
      right: 0;
      width: 0;
      height: 0;
      border-top: 34px solid #20a0ff;
      border-left: 34px solid transparent;
      color: #fff;
    }
    label {
      position: absolute;
      top: -34px;
      right: 0;
      width: 20px;
      height: 20px;
      line-height: 20px;
    }
  }
  .item-bg {
    position: absolute;
    left: 0;
    bottom: -101%;
    width: 100%;
    height: 100%;
    background: rgba(241, 244, 246, .9);
    text-align: left;
    border-radius: 5px;
    padding-top: 8px;
    transition: all .4s ease;
    p {
      padding: 0 10px;
    }
    .item-operate {
      position: absolute;
      left: 0;
      bottom: 0;
      background: rgba(0, 0, 0, .4);
      width: 100%;
      padding: 4px 0;
      text-align: center;
      cursor: pointer;
      a { color: #fff; }
    }
  }
  .coupon-item:hover {
    .item-bg {
      bottom: 0;
    }
  }
  .coupon-type-item {
    position: relative;
    padding: 30px 10px;
    border: 1px solid #ff5000;
    color: #ff5000;
    border-radius: 5px;
    text-align: center;
    margin-bottom: 20px;
    background: #fff;
    overflow: hidden;
    cursor: pointer;
    &:first-child {
      font-size: 18px;
    }
    .coupon-type-desc {
      position: absolute;
      width: 100%;
      height: 100%;
      bottom: -100%;
      left: 0;
      padding: 10px 0;
      background: #ff5000;
      color: #fff;
      font-size: 18px;
      transition: all .4s ease;
      div:last-child {
        width: 70%;
        margin: 8px auto 0;
        font-size: 12px;
      }
    }
    &:hover {
      .coupon-type-desc {
        bottom: 0;
      }
    }
  }

  .coupon-type-item, .sendout-item {
    overflow: hidden;
    .icon-checked {
      display: none;
      width: 100px;
      height: 25px;
      transform: rotate(35deg);
      position: absolute;
      font-size: 14;
      top: 5px;
      right: -25px;
      font-size: 20px;
      color: #fff;
      background: #ff5000;
      i {
        transform: rotate(-35deg);
      }
    }
    &.checked {
      .icon-checked {
        display: block;
      }
    }

    &:hover .icon-checked {
      background: #fff;
      i {
        color: #ff5000;
      }
    }
  }
  .store-pop {
    padding: 20px 15px;
    .store-content {
      margin-bottom: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// coupon.vue?5270d62a